import $ from 'jquery';
import 'sharer.js';

$('.share-buttons-wrapper').hover(
    function () {
        $('.share-buttons-inner').addClass('active');
    },
    function () {
        $('.share-buttons-inner').removeClass('active');
    }
);